import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight

import { ToastContainer, toast } from "react-toastify";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

import { ShoppingCart } from "@mui/icons-material";


import { addRecord, getAllRecords, USERS_STORE, PRODUCT_STORE, OTHERPRODUCT_STORE, RATE_STORE, loginUser, getAllUsers } from "../dbControllers/dbController";

const Login = () => {
  const [userEmail, setUserEmail] = useState("");
  const [userPin, setUserPin] = useState("");
  const [posting, setPosting] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async () => {
    if (userEmail == "") {
      toast.warn("Proceeding failed. Fill in your username", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (userPin == "") {
      toast.warn("Proceeding failed. Fill in the your password", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPosting(true);

    // Step 1: check if any users exist locally
    const localUsers = await getAllRecords(USERS_STORE);

    if (localUsers.length === 0) {
      const dataObj = {
        email: userEmail,
        password: userPin,
      };

      const baseUrl = apilink.link;
      axios
        .post(`${baseUrl}pos/auth`, dataObj)
        .then(async (response) => {
          console.log(response.data.data.users)
          if (response.data.message === "Login successful") {

            // Step 2: add users to IndexedDB
            for (const user of response.data.data.users) {
              await addRecord(USERS_STORE, {
                authid: user.authid,
                id: user.id,
                fullname: user.fullname,
                email: user.email,
                phone: user.phone,
                account: user.account,
                password: user.password,
                changepswd: user.changepswd,
                shopid: user.shopid,
                position: user.position,
                shopname: user.shopname,
                location: user.location,
                changedpinat: null,
              });
            }

            // Step 3: add shopproducts to IndexedDB
            for (const prod of response.data.data.products) {
              await addRecord(PRODUCT_STORE, {
                productid: prod.productid,
                product: prod.product,
                salemode: prod.salemode,
                price: parseFloat(prod.price),
                fromain: prod.total_from_main
              });
            }

            // Step 4: add nonshopproducts to IndexedDB
            for (const nonshop of response.data.data.nonshopproducts) {
              await addRecord(OTHERPRODUCT_STORE, {
                shopid: nonshop.id,
                shopname: nonshop.shopname,
                productid: nonshop.productid,
                product: nonshop.product,
                salemode: nonshop.salemode,
                price: parseFloat(nonshop.price)
              });
            }

            // Step 5: add rates to IndexedDB

            const options = {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit"
            };

            for (const curr of response.data.data.currencyrates) {
              const jsDate = new Date(curr.updated_at.replace(" ", "T"));
              const formatted = jsDate.toLocaleString("en-GB", options);
              await addRecord(RATE_STORE, {
                currency: curr.currency,
                usdrate: parseFloat(curr.usdrate),
                formatted
              });
            }

            // 🔍 Find user by email
            const matchedUser = response.data.data.users.find(user => user.email === userEmail);

            setPosting(false);
            setUserEmail("");
            setUserPin("");

            console.log(matchedUser);
            localStorage.setItem("userData", JSON.stringify(matchedUser));
            navigate("/app/home");
            return;
          }
        })
        .catch((err) => {
          setPosting(false);
          toast.warn(err.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });

    } else {
      try {
        const matchedUser = await loginUser(userEmail, userPin);
        setPosting(false);
        setUserEmail("");
        setUserPin("");

        console.log(matchedUser);
        localStorage.setItem("userData", JSON.stringify(matchedUser));
        navigate("/app/home");
      } catch (err) {
         setPosting(false);
          toast.warn("Invalid email or password. Please try again", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        console.error("Login error: " + err.message);
      }
    }




  }
  const handleAdminSignIn = () => {
    navigate("/signin");
  }
  return (
    <>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "76px",
          paddingInline: 30,
        }}
      >
        <ShoppingCart
          style={{
            color: '#ffffff',
            backgroundColor: '#EA6C82',
            padding: 10,
            width: "70px",
            height: "70px",
            borderRadius: 35,
            border: "2px solid #547FF7", // <-- this is the fix
            fontSize: "40px"
          }}
        />
        <h1
          className="navbar-brand mb-0"
          style={{
            color: "#EA6C82",
            fontFamily: "Open Sans",
            marginTop: "80px",
            fontSize: "30px"
          }}
        >
          Fusion<b>POS</b>
        </h1>
        <p
          style={{
            color: "#a9a9a9",
            fontFamily: "Open Sans",
            marginTop: "25px",
          }}
        >
          Sign In
        </p>

        <input
          style={{
            width: "315px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            paddingInline: 10,
            marginBottom: "10px",

          }}
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          type="text"
          placeholder="Username"
          maxlength={50}
        />
        <input
          style={{
            width: "315px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            paddingInline: 10,
            marginBottom: "10px",

          }}
          value={userPin}
          onChange={(e) => setUserPin(e.target.value)}
          type="password"
          placeholder="Password"
          maxlength={30}
        />
        <button
          onClick={() => handleSignIn()}
          style={{
            width: "315px",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
          className="form-control"
        >
          {posting === false && <>Proceed</>}
          {posting && (
            <>
              <Squares />
            </>
          )}
        </button>
        <p
          onClick={() => handleAdminSignIn()}
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "30px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          Forgot Password <span style={{ color: "#EA6C82" }}>Recover</span>
        </p>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default Login;
